import { render, staticRenderFns } from "./createRepairSupport.vue?vue&type=template&id=6b3cf378&"
import script from "./createRepairSupport.vue?vue&type=script&lang=js&"
export * from "./createRepairSupport.vue?vue&type=script&lang=js&"
import style0 from "./createRepairSupport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports